interface BodyLocationNailsProps {
  className?: string;
  pathClassName?: string;
}

export function BodyLocationNails({ className, pathClassName }: BodyLocationNailsProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M30.7284 4.3709L30.6722 3.13384C30.5924 1.37663 29.1518 0 27.3925 0H20.6088C18.8495 0 17.409 1.37663 17.3292 3.13384L17.273 4.37108C14.3039 6.48239 12.3613 9.94762 12.3613 13.86V44.8586C12.3613 46.5907 13.7706 48 15.5027 48H32.4988C34.2309 48 35.6401 46.5907 35.6401 44.8586V13.86C35.6401 9.94744 33.6976 6.48222 30.7284 4.3709ZM19.889 3.24999C19.9066 2.86428 20.2227 2.56228 20.609 2.56228H27.3927C27.7789 2.56228 28.0951 2.86446 28.1127 3.25016L28.6012 13.9972C27.2085 13.4468 25.63 13.153 24.0007 13.153C22.3716 13.153 20.7929 13.447 19.4004 13.9974L19.889 3.24999ZM27.9805 16.5151C27.1347 17.971 25.5934 18.79 24.0257 18.79H23.976C22.4229 18.79 20.8744 17.9838 20.021 16.5151C21.1832 15.9956 22.5583 15.7153 24.0007 15.7153C25.4431 15.7153 26.8184 15.9956 27.9805 16.5151ZM33.0779 44.8586C33.0779 45.1779 32.818 45.4377 32.4988 45.4377H15.5027C15.1834 45.4377 14.9236 45.1779 14.9236 44.8586V13.86C14.9236 11.6097 15.7487 9.54944 17.1097 7.96168L16.8404 13.8857C16.656 17.9472 19.9083 21.3523 23.9758 21.3523H24.0255C28.0915 21.3523 31.3454 17.9491 31.1608 13.8855L30.8914 7.96151C32.2525 9.54927 33.0775 11.6095 33.0775 13.8599L33.0779 44.8586Z"
        fill="var(--gray-300)"
        className={pathClassName}
      />
      <path
        d="M30.0454 39.7259H17.9558C17.2481 39.7259 16.6746 40.2993 16.6746 41.007C16.6746 41.7147 17.2481 42.2882 17.9558 42.2882H30.0454C30.7531 42.2882 31.3266 41.7147 31.3266 41.007C31.3266 40.2993 30.753 39.7259 30.0454 39.7259Z"
        fill="var(--gray-300)"
        className={pathClassName}
      />
    </svg>
  );
}
